import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const Endpoint = '/api/categorias-productos';


const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const obtenerCategoriasProductos = async () => {
    try {
        const response = await axios.get(`${baseUrl}${Endpoint}`);
        
        if (response.data.success) {
            return {
                success: true,
                categorias: response.data.data.categorias,
                productos: response.data.data.productos
            };
        } else {
            return {
                success: false,
                message: 'No se pudieron obtener las categorías y productos'
            };
        }
    } catch (error) {
        console.error('Error al obtener categorías y productos:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Error al conectar con el servidor'
        };
    }
};
  export default obtenerCategoriasProductos;